/**
 * @module enum
 */
export enum FriendResponseTypeEnum {
    /**
     * 同意添加单向好友
     */
    V2TIM_FRIEND_ACCEPT_AGREE,
    /**
     * 同意添加双向好友
     */
    V2TIM_FRIEND_ACCEPT_AGREE_AND_ADD,
}
